var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-charts"},[_c('ve-histogram',{ref:"barChart",attrs:{"width":"100%","height":"100%","data":_vm.barChartData,"settings":_vm.barChartSetting,"colors":_vm.chartColors,"grid":_vm.barGrid,"extend":_vm.barChartExtend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }